import classNames from 'classnames'
import { ReactComponent as CheckIcon } from '../../../Icons/ic_check.svg'
import styles from './HeaderLinkDropdown.module.scss'

type HeaderLinkDropdownItemProps = {
  isSelected: boolean
  icon?: React.ReactNode
  onClick: () => void
  children: React.ReactNode
}

export const HeaderLinkDropdownItem = ({
  isSelected,
  icon,
  onClick,
  children,
}: HeaderLinkDropdownItemProps) => {
  return (
    <li className={styles.nestedItem} style={{ marginRight: '0px' }}>
      <button onClick={onClick} className={styles.nestedDropdownItem}>
        <div>
          {icon && icon}
          <span
            className={classNames({
              [styles.selected]: isSelected,
            })}
          >
            {children}
          </span>
        </div>
        {isSelected && <CheckIcon className="icon ml-auto" />}
      </button>
    </li>
  )
}
